<template>
  <section v-if="completeLoadingTarget">
    <!-- Comtact role -->
    <div id="accordion">
      <div class="card">
        <div class="card-header p-0 d-flex align-items-center" id="headingTwo">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                {{ $t("lang.category_job_group.contact_role") }}
              </button>
            </h5>
          </div>

          <!-- <div class="col-3 text-right"
          v-if="categoryKey != ''">
              <span
                class="text-primary"
                :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
                :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <i  v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
               <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
                >
                <i class="icon-pencil text-gray"></i>
               </Tooltip>
              </span>
              <span
                class="text-primary  mx-2"
                :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
                @click="!(isDisabled || selectDisable) ? deleteFilter('role') : ''"
              >
                <i  v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
                <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
                >
                <i class="icon-close text-gray"></i>
              </Tooltip>
              </span>
          </div> -->
        </div>
        <div
          id="collapseThree"
          class="collapse show"
          aria-labelledby="headingTwo"
          data-parent="#accordion"
        >
          <div class="card-body">
            <Tabs
              :tabSelected="tabSelected"
              :tabs="tabs"
              @change="changeTab($event)"
            />

            <div class="mt-3" v-if="tabSelected == 1">
               <select
                v-model="categoryKey"
                class="d-inline form-control"
                :disabled="isDisabled || selectDisable"
                @change="setCategories()"
              >
                <option
                  v-for="item in categories_jobs_group.filter( e => e.category != 'Custom_Job_Titles')"
                  :key="item.category"
                  :value="item.category"
                  class="optionSelect"
                  :class="{
                    'text-primary': item.category === 'Custom_Job_Titles',
                    'font-weight-bold': item.category === 'Custom_Job_Titles'
                  }"
                >
                  {{ $t("lang.category_job_group." + item.category) }}
                </option>
              </select>

              <div class="mt-3">
                <span
                  v-if="loadingCategory"
                  class="loadingres mr-2 ml-2 spinner-border loading-spinner"
                ></span>
                <KeyWordSearch
                  :taglimit="99"
                  :multipleValuesAtOnce="true"
                  :isDisabled="isDisabled || selectDisable"
                  ref="jobtilte"
                  :default_values="target.data.categories_jobs"
                  @change="changeKeywords($event)"
                  :anyOf="valueAnyOf"
                />
              </div>
            </div>
            <div class="mt-3" v-if="tabSelected == 2">
              <span
                v-if="loadingCategory"
                class="loadingres mr-2 ml-2 spinner-border loading-spinner"
              ></span>
              <KeyWordSearch
                :taglimit="99"
                :multipleValuesAtOnce="true"
                :isDisabled="true"
                ref="jobtilte"
                :default_values="target.data.categories_jobs"
                @change="changeKeywords($event)"
                :anyOf="valueAnyOf"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Industry -->
    <div id="accordion">
      <div class="card mt-2">
        <div class="card-header p-0 d-flex align-items-center" id="headingTwo">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#industry"
                aria-expanded="false"
                aria-controls="industry"
              >
                {{ $t("lang.category_job_group.industry") }}
              </button>
            </h5>
          </div>

          <!-- <div
            class="col-3 text-right"
            v-if="
              target.data.categories_industry.length > 0 ||
                target.data.categories_not_industry.length > 0
            "
          >
            <span
              class="text-primary"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
              data-target="#industry"
              aria-expanded="false"
              aria-controls="industry"
            >
              <i  v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
              <Tooltip
              v-else
              :text="$t('lang.label.target_no_editable')"
              :width="''"
              >
              <i class="icon-pencil text-gray"></i>
              </Tooltip>
            </span>
            <span
              class="text-primary  mx-2"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              @click="!(isDisabled || selectDisable) ? deleteFilter('industry') : ''"
            >
               <i  v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
                <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
                >
                <i class="icon-close text-gray"></i>
                </Tooltip>
            </span>
          </div> -->
        </div>
        <div
          id="industry"
          class="collapse "
          aria-labelledby="industry"
          data-parent="#accordion"
        >
          <div class="card-body">
            <!-- <h6 class="mt-4">{{ $t("lang.onBoarding.step2_4_question") }}</h6> -->
            <span
              v-if="loadingCategory"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>
            <p v-if="!loadingCategory" class="mt-2">
              {{ $t("lang.onBoarding.include") }}
            </p>

            <IndustrySearch
              v-if="!loadingCategory"
              :option_list="
                this.$store.state.optionsList.all.categories_google_all.data
              "
              :default_values="target.data.categories_industry"
              :isDisabled="isDisabled || selectDisable"
              :fromOrder="true"
              @closed="changeSomething()"
            >
              </IndustrySearch>
              <p v-if="!loadingCategory" class="mt-2">
                {{ $t("lang.onBoarding.exclude") }}
              </p>
              <IndustrySearch
                v-if="!loadingCategory"
                :option_list="
                  this.$store.state.optionsList.all.categories_google_all.data
                "
                :default_values="target.data.categories_not_industry"
                :isDisabled="isDisabled || selectDisable"
                :fromOrder="true"
                :openDirection="'top'"
                @closed="changeSomething()"
              >
              </IndustrySearch>
          </div>
        </div>
      </div>
    </div>

    <!-- Sizes -->
    <div id="accordion">
      <div class="card mt-2">
        <div class="card-header p-0 d-flex align-items-center" id="headingTwo">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#headcount"
                aria-expanded="false"
                aria-controls="headcount"
              >
                {{ $t("lang.category_job_group.companyHeadCount") }}
              </button>
            </h5>
          </div>

          <div class="col-3 text-right"
          v-if="onBoarding.target.sizes.length > 0">
            <span
              class="text-primary"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
              data-target="#headcount"
              aria-expanded="false"
              aria-controls="headcount"
            >
               <i  v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
              <Tooltip
              v-else
              :text="$t('lang.label.target_no_editable')"
              :width="''"
              >
              <i class="icon-pencil text-gray"></i>
              </Tooltip>
            </span>
            <span
              class="text-primary mx-2"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              @click="!(isDisabled || selectDisable) ? deleteFilter('headcount') : ''"
            >
               <i  v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
                <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
                >
                <i class="icon-close text-gray"></i>
                </Tooltip>
            </span>
          </div>
        </div>
        <div
          id="headcount"
          class="collapse "
          aria-labelledby="headcount"
          data-parent="#accordion"
        >
          <div class="card-body">
            <span
              v-if="!loadingCategorySize"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>
            <IndustrySearch
              v-if="loadingCategorySize"
              :option_list="select_list_sizes"
              :default_values="sizes"
              :isDisabled="true"
              :fromOrder="true"
              @closed="changeSomething()"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Locations -->
    <div id="accordion">
      <div class="card mt-2">
        <div class="card-header p-0 d-flex align-items-center" id="headingTwo">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#geography"
                aria-expanded="false"
                aria-controls="geography"
              >
                {{ $t("lang.category_job_group.geography") }}
              </button>
            </h5>
          </div>

          <div
            class="col-3 text-right"
            v-if="onBoarding.target.contact_country.length > 0"
          >
            <span
              class="text-primary"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
              data-target="#geography"
              aria-expanded="false"
              aria-controls="geography"
            >
                <i  v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
              <Tooltip
              v-else
              :text="$t('lang.label.target_no_editable')"
              :width="''"
              >
              <i class="icon-pencil text-gray"></i>
              </Tooltip>
            </span>
            <span
              class="text-primary mx-2"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              @click="!(isDisabled || selectDisable) ? deleteFilter('geography') : ''"
            >
               <i  v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
                <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
                >
                <i class="icon-close text-gray"></i>
                </Tooltip>
            </span>
          </div>
        </div>
        <div
          id="geography"
          class="collapse "
          aria-labelledby="geography"
          data-parent="#accordion"
        >
          <div class="card-body">
            <span
              v-if="loadingCategory"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>
            <IndustrySearch
              v-if="!loadingCategory"
              class="mb-4"
              :option_list="this.$store.state.optionsList.all['countries'].data"
              :default_values="this.target.data.countries"
              :isDisabled="true"
              :openDirection="'top'"
              :fromOrder="true"
              @closed="changeSomething()"
            >
            </IndustrySearch>
          </div>
        </div>
      </div>
    </div>

    <div id="accordion">
      <div class="card mt-2">
        <div class="card-header p-0 d-flex align-items-center" id="headingTwo">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#location"
                aria-expanded="false"
                aria-controls="location"
              >
                {{ $t("lang.category_job_group.companyHeadQuarterLocation") }}
              </button>
            </h5>
          </div>

          <div
            class="col-3 text-right"
            v-if="onBoarding.target.company_location.length > 0"
          >
            <span
              class="text-primary"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
              data-target="#location"
              aria-expanded="false"
              aria-controls="location"
            >
              <i  v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
              <Tooltip
              v-else
              :text="$t('lang.label.target_no_editable')"
              :width="''"
              >
              <i class="icon-pencil text-gray"></i>
              </Tooltip>
            </span>
            <span
              class="text-primary mx-2"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              @click="!(isDisabled || selectDisable) ? deleteFilter('location') : ''"
            >
              <i  v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
                <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
                >
                <i class="icon-close text-gray"></i>
                </Tooltip>
            </span>
          </div>
        </div>
        <div
          id="location"
          class="collapse "
          aria-labelledby="location"
          data-parent="#accordion"
        >
          <div class="card-body">
            <!-- <h6 class="mt-4">{{ $t("lang.onBoarding.step2_4_question") }}</h6> -->
            <span
              v-if="loadingCategory"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>
            <!-- @deleted="removeOption($event)" -->
            <IndustrySearch
              class="mt-3"
              v-if="!loadingCategory"
              :option_list="placesOptions"
              :default_values="selectedOptions"
              :isDisabled="true"
              :fromOrder="true"
            >
            </IndustrySearch>

            <!-- <IndustrySearch
              v-if="!loadingCategory"
              :option_list="this.$store.state.optionsList.all['regions'].data"
              :default_values="this.target.data.region"
              :isDisabled="true"
              :fromOrder="true"
              @closed="changeSomething()"
            >
            </IndustrySearch> -->
          </div>
        </div>
      </div>
    </div>



    <div id="accordion">
      <div class="card mt-2">
        <div class="card-header p-0 d-flex align-items-center" id="headingFive">
          <div class="col-9 p-0">
            <h5 class="mb-0">
              <button
                class="btn btn-link text-dark collapsed"
                data-toggle="collapse"
                data-target="#industry_keywords"
                aria-expanded="false"
                aria-controls="industry_keywords"
              >
                {{ $t("lang.search.keywords") }}
              </button>
            </h5>
          </div>

          <div
            class="col-3 text-right"
            v-if="
              (onBoarding.target.industry_keywords.anyof !== undefined && onBoarding.target.industry_keywords.anyof.length > 0) ||
              (onBoarding.target.industry_keywords.notanyof !== undefined && onBoarding.target.industry_keywords.notanyof.length > 0)
            "
          >
            <span
              class="text-primary"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              :data-toggle="!(isDisabled || selectDisable) ? 'collapse' : ''"
              data-target="#industry_keywords"
              aria-expanded="false"
              aria-controls="industry_keywords"
            >
                <i v-if="!(isDisabled || selectDisable)" class="icon-pencil"></i>
              <Tooltip
              v-else
              :text="$t('lang.label.target_no_editable')"
              :width="''"
              >
              <i class="icon-pencil text-gray"></i>
              </Tooltip>
            </span>
            <span
              class="text-primary mx-2"
              :class="{ 'cursor-pointer': !(isDisabled || selectDisable) }"
              @click="!(isDisabled || selectDisable) ? deleteFilter('industry_keywords') : ''"
            >
                 <i  v-if="!(isDisabled || selectDisable)" class="icon-close"></i>
                <Tooltip
                v-else
                :text="$t('lang.label.target_no_editable')"
                :width="''"
                >
                <i class="icon-close text-gray"></i>
                </Tooltip>
            </span>
          </div>
        </div>
        <div
          id="industry_keywords"
          class="collapse "
          aria-labelledby="industry_keywords"
          data-parent="#accordion"
        >
          <div class="card-body">
            <span
              v-if="loadingCategory"
              class="loadingres mr-2 ml-2 spinner-border loading-spinner"
            ></span>

                <KeyWordSearch
                  :isDisabled="isDisabled || selectDisable"
                  v-if="!loadingCategory"
                  @change="changeKeywords($event)"
                  ref="industry_keywords"
                  :default_values="this.target.data.industry_keywords"
                />
          </div>
        </div>
      </div>
    </div>


    <!-- <Fieldset
      class="mt-2"
      :title="$t('lang.category_job_group.companyHeadQuarterLocation')"
      :mykey="5"
      :open="false"
      :classButton="'btn btn-link text-dark'"
    >

      <IndustrySearch
        :option_list="this.$store.state.optionsList.all['regions'].data"
        :default_values="onBoarding.target.company_location"
        :isDisabled="isDisabled || selectDisable"
        :fromOrder="true"
        @closed="changeSomething()"
      >
      </IndustrySearch>
    </Fieldset> -->
  </section>
</template>

<script>
import IndustrySearch from "@/components/AccountCreation/Steps/Campaign/search/IndustrySearch.vue";
import { targetsService } from "@/_services";
import Tabs from "@/components/Common/Tabs.vue";
import Fieldset from "@/components/Common/Fieldset.vue";
import { mapState, mapActions } from "vuex";
import KeyWordSearch from "@/components/AccountCreation/Steps/Campaign/search/KeyWordSearch.vue";
import Tooltip from "@/components/Common/Tooltip.vue";

export default {
  props: {
    selectDisable: {
      type: Boolean,
      required: false,
      default: () => true
    },
    poupView: {
      type: Boolean,
      required: false,
      default: () => false
    },
    target: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  data() {
    return {
      selectedOptions: [],
      placesOptions: [],
      sizes:[],
      tabSelected: 1,
      size: {
        greater: 0,
        less: 0
      },
       tabs: {
        1: {
          id: 1,
          name: this.$t('lang.orders.predefined_audience'),
          disabled: (this.isDisabled || this.selectDisable)
        },
        2: {
          id: 2,
          name: this.$t('lang.orders.title_job_custom'),
          disabled: (this.isDisabled || this.selectDisable)
        }
      },
      keywordscant: 0,
      addSelect: false,
      categoryKey: "General_Management_Owners",
      loadingCategory: false,
      loadingCategorySize: false,
      apollo: {
        total_result: 0,
        people: []
      },
      valueAnyOf: false,
      valNotAnyOf: true,
      fieldsetHtml: "",
      data: {
        categories_industry: [],
        categories_not_industry: [],
        employees: {
          keywords: {
            greater: 0,
            less: 0
          }
        },
        categories_level: [],
        categories_function: [],
        categories_jobs: {},
        industry_keywords:{},
        region: [],
        countries: []
      },
      select_list_sizes: [
        { id: 0, label: "1-10" },
        { id: 1, label: "11-20" },
        { id: 2, label: "21-50" },
        { id: 3, label: "51-100" },
        { id: 4, label: "101-200" },
        { id: 5, label: "201-500" },
        { id: 6, label: "501-1000" },
        { id: 7, label: "1001-2000" },
        { id: 8, label: "2001-5000" },
        { id: 9, label: "5001-10000" },
        { id: 10, label: "10001+" }
      ],
      selected_sizes: []
    };
  },

  components: {
    IndustrySearch,
    KeyWordSearch,
    Fieldset,
    Tabs,
    Tooltip
  },
  computed: {
    ...mapState({
      completeLoadingTarget: state => state.optionsList.completeLoadingTarget,
      onBoarding: state => state.onboarding,
      isDisabled: state => state.onboarding.isDisable,
      categories_jobs_group: state =>
        state.optionsList.all["category_jobs_group"].data
    })
  },
  created() {
    if (!this.onBoarding.completeLoadingTarget) {
      this.$store.dispatch("optionsList/getAllTargetParams");
    }

    this.selected_sizes = this.onBoarding.target.sizes;
    this.addSelect = true;


    if (this.poupView) {
      //this.getApollo();
    }
  },
  mounted() {
    this.categories_jobs_group.map(element => {
      if (this.target.data.category_select == element.category) {
        this.categoryKey = element.category;
        if (this.categoryKey == "Custom_Job_Titles") {
          this.valueAnyOf = true;
          this.tabSelected = 2
        }
      }
    });

    if (this.categoryKey == "General_Management_Owners"){
      this.setCategories();
    }

    this.proccessSizes();

    if ( this.target.data.places && this.target.data.places.length > 0 ) {
      this.target.data.places.forEach(item => {
        let element = {
          id: item,
          label: item
        };
        this.placesOptions.push(element);
        this.selectedOptions.push(item);
      });
    }

  },

  methods: {
    ...mapActions("onboarding", {
      getApollo: "getApollo",
      calculateSize: "calculateSize",
      updateCategorySelect: "updateCategorySelect"
    }),
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    proccessSizes(){
         if (_.has(this.target.data.employees, 'keywords')) {
              this.sizes = []
              this.size = { keywords: {} }
              this.size.keywords.greater =
                this.target.data.employees.keywords.greater
              this.size.keywords.less = this.target.data.employees.keywords.less
              this.select_list_sizes.forEach((item) => {
                let label = item.label.replace('+', '').split('-')
                let less = label[0]
                let greater = label[1]
                if (
                  less <= this.size.keywords.less &&
                  greater >= this.size.keywords.greater
                ) {
                  this.sizes.push(item.id)
                }
                if (
                  greater == undefined &&
                  this.size.keywords.less == '10000000'
                ) {
                  this.sizes.push(item.id)
                }
              })
            } else {
              if (_.has(this.target.data, 'employees')) {
                if (this.target.data.employees.greater == undefined) {
                  this.size = this.target.data.employees
                  let greater = 0
                  let less = 0
                  //state.target.sizes.sort()
                  //onboarding.mutations.calculateSize(state)
                }
              }
            }
            this.loadingCategorySize = true
    },
    changeTab(id) {
      this.tabSelected = id;
      if(id === 2) {
        this.categoryKey = 'Custom_Job_Titles';
        this.setCategories();
      } else {
        this.categoryKey = "General_Management_Owners";
        this.setCategories();
      }
    },

    setCategories() {
      this.loadingCategory = true;
      this.valueAnyOf = false;
      let targetJobs = this.onBoarding.target.categories_jobs;
      this.updateCategorySelect(this.categoryKey);
      targetJobs.anyof = [];
      if (this.categoryKey != "Custom_Job_Titles") {
        this.categories_jobs_group.map(element => {
          if (element.category == this.categoryKey) {
            let values = element.words.split(",");
            values.forEach(element => {
              targetJobs.anyof.push({ word: element });
            });
          }
        });
      }
      this.changeKeywords(targetJobs);
    },
    changeKeywords(e) {
      this.changeSomething();

      setTimeout(() => {
        if (this.categoryKey == "Custom_Job_Titles") {
          this.valueAnyOf = true;
        }

        this.loadingCategory = false;
      }, 1000);
    },

    deleteFilter(filter) {
      this.loadingCategory = true;
      //console.log(filter);
      let targetJobs = this.onBoarding.target;
      //console.log(targetJobs);
      if (filter == "location") {
        targetJobs.company_location = [];
      }

      if (filter == "industry") {
        targetJobs.sectors_include = [];
        targetJobs.sectors_exclude = [];
      }

      if (filter == "industry_keywords") {
        targetJobs.industry_keywords = {};
        targetJobs.industry_keywords.anyof = [];
        targetJobs.industry_keywords.notanyof = [];
      }

      if (filter == "geography") {
        targetJobs.contact_country = [];
      }

      if (filter == "headcount") {
        targetJobs.sizes = [];
      }

      if (filter == "role") {
        targetJobs.categories_jobs.anyof = [];
        targetJobs.categories_jobs.notanyof = [];
        this.categoryKey = "";
        this.updateCategorySelect(this.categoryKey);
      }
      //console.log(targetJobs);

      this.changeKeywords(targetJobs);
    },

    changeSomething() {
      if (this.poupView) {
        //this.getApollo();
      } else {
        this.calculateSize();
        //this.getApollo();
      }
    }
  }
};
</script>
<style  scoped>
  .text-gray {
    color:darkgray
  }
</style>
